import { BookingSummaryTicket } from './booking-summary-ticket';
import { IChildEducationDetails } from './child-education-details.interface';
import { ICustomerDetails } from './customer-details.interface';
import { CustomerTypeIds } from './customer-type.enum';
import { DeliveryMethod } from './delivery-method';
import { IMTicketDetails } from './m-ticket-details.interface';
import { IStudentDetails } from './student-details.interface';
import { ISwiftCardInfoDetails } from './swift-card-info.interface';

export interface BookingSummaryItem {
  forBasket: string;
  basketItemId: number;
  quantityIndex: number;
  customerType: CustomerTypeIds;
  customerTypeName: string;
  customerDetails?: ICustomerDetails;
  childEducationDetails?: IChildEducationDetails;
  studentDetails?: IStudentDetails;
  mTicketEnabled: boolean;
  swiftEnabled: boolean;
  selectedDeliveryMethod?: DeliveryMethod;
  ticket: BookingSummaryTicket;
  mTicketDetails: IMTicketDetails;
  swiftCardDetails: ISwiftCardInfoDetails;
  ticketIsForApplicant?: string | number;
}
